import { Box, Container, GlobalStyles, Stack } from '@mui/material'

import BrandLogo from 'ui-components/components/atoms/BrandLogo'
import JoinWorkspaceCopy from 'ui-components/components/organisms/JoinWorkspacePanels/JoinWorkspaceCopy'

const Overrides = (
  <GlobalStyles
    styles={{
      'html, body, #__next': {
        height: '100%'
      },
      body: {
        overflowY: 'scroll'
      }
    }}
  />
)

const Empty = () => null

const defaultSlots = {
  MemberAvatarGroup: Empty,
  AuthForm: Empty
}

const JoinWorkspace = (props) => {
  const {
    loading,
    workspaceName,
    slots: Slots = defaultSlots,
    slotProps
  } = props

  return (
    <>
      {Overrides}

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: (theme) => theme.palette.background.paper,
          py: 8
        }}
      >
        <Box
          component={Container}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <BrandLogo
            variant='logoCopy'
            size='lg'
          />
          <JoinWorkspaceCopy
            loading={loading}
            workspaceName={workspaceName}
          />
        </Box>
        <Slots.MemberAvatarGroup />
      </Box>

      <Box
        component={Container}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          p: 8
        }}
      >
        <Stack
          my={4}
          width={{
            xs: '100%',
            sm: '400px'
          }}
          spacing={3}
          sx={{ justifyContent: 'center' }}
        >
          <Slots.AuthForm slotProps={slotProps?.AuthForm} />
        </Stack>
      </Box>
    </>
  )
}

export { JoinWorkspace }
export default JoinWorkspace
